module.exports = __webpack_public_path__ + "static/aircrackng-3b5764c3236dabc5ae88a15ef48ca702.svg";